export default {
  container: {
    background: '#fff',
    minHeight: '100%',
  },
  editPanel: {
    padding: 0,
    width: '100%',
    fontSize: '1.2rem',
    minHeight: '100%',
    // overflow: 'hidden'
  },
}
